<app-create-edit-with-tree [data]="inputData"></app-create-edit-with-tree>
